export default __webpack_public_path__ + "assets/21fac676d4a152cb019e995ec686929c.svg";